import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUndoUpLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Arrow / Arrow_Undo_Up_Left",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M7 13L3 9M3 9L7 5M3 9H16C18.7614 9 21 11.2386 21 14C21 16.7614 18.7614 19 16 19H11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgArrowUndoUpLeft;
